import React, {useRef, useState} from "react";
import S from './Event.module.scss';
import {useNavigate, useParams} from "react-router-dom";
import {Anchor, Breadcrumbs, Group, Image, Paper} from "@mantine/core";
import {Questions} from "../../widgets/questions";
import {Program} from "../../widgets/program";
import {HallLayout} from "../../widgets/hallLayout";
import {Carousel} from "@mantine/carousel";
import AutoScroll from "embla-carousel-auto-scroll";
import {PartnersModal} from "../../widgets/partnersModal";
import {useDisclosure} from "@mantine/hooks";
import {Registration} from "../../widgets/registration";
import {eventPage} from "../../shared/mock/eventPage";
import {Photo} from "../../widgets/photo";
import bannerBackground from "../../shared/assets/images/bannerBackground.png";
import logistic from "../../shared/assets/images/Logistic.png";
import digitalization from "../../shared/assets/images/Digitalization1.png";
import {DescriptionEvent, DescriptionEventContacts} from "../../widgets/descriptionEvent";
import {EventSubscription} from "../../widgets/eventSubscription";
import {Contacts} from "../../widgets/contacts";
import {ModalWindow} from "../../widgets/modal";
import {ParticipationFormats} from "../../widgets/participationFormats";
import {DescriptionQuestionEvent} from "../../widgets/descriptionEvent";

export const Event = () => {
    const { titleUrl } = useParams();
    const event = eventPage.find((item) => item.titleUrl === titleUrl);

    const navigate = useNavigate();

    const items = [
        { title: 'Главная', url: '/' },
        { title: `${event?.description}`, active: true },
    ].map((item, index) => (
        <Anchor
            onClick={() => item.url && navigate(item.url)}
            key={index}
            data-active={item.active || undefined}
            className={S.breadcrumbItem}
        >
            {item.title}
        </Anchor>
    ));

    const autoScroll = useRef(
        AutoScroll({
            speed: 1,
            stopOnInteraction: false,
            stopOnMouseEnter: true,
        })
    );
    const [openModalId, setOpenModalId] = useState();
    const [opened, { open, close }] = useDisclosure(false);
    const handleOpenModal = (id: any) => {
        setOpenModalId(id);
        open();
    };

    const [openedModal, {open: openModal, close: closeModal}] = useDisclosure(false);

    return (
        <section id='event'>
            <div className={S.section}>
                <div className={S.content}>
                    <Breadcrumbs>
                        {items}
                    </Breadcrumbs>
                    <div className={S.boxContent}>
                        <div className={S.boxTitle}>
                            <div className={S.boxTitleDate}>
                                <div>
                                    <div className={event?.id === 5 ? S.statusBoxLogistics : S.statusBox}>{event?.status}</div>
                                    <div className={S.boxTitleLogo}>
                                        <div className={S.year}>{event?.year}</div>
                                        <div className={S.titleLogo}>{event?.title}</div>
                                    </div>
                                    <div
                                        className={`${S.textLogo} ${event?.id === 5 ? S.colorLogistics : S.colorMain}`}
                                    >
                                        {event?.description}
                                    </div>
                                </div>
                            </div>
                            <div className={S.boxVenue}>
                                <div className={S.titleVenue}>МЕСТО ПРОВЕДЕНИЯ:</div>
                                <div className={`${S.textVenue} ${event?.id === 5 ? S.colorLogistics : S.colorMain}`}>{event?.location}</div>
                            </div>
                            {event?.date?.length ? (
                                <div className={S.divDate}>
                                    <div className={S.titleVenue}>ДАТА ПРОВЕДЕНИЯ:</div>
                                    <div
                                        className={`${S.dateText} ${event?.id === 5 ? S.colorLogistics : S.colorMain}`}>
                                        {event?.date?.map((item, index) => (
                                            <div key={index}>{item}</div>
                                        ))}
                                    </div>
                                </div>
                            ) : null}
                            <button
                                className={`${S.button} ${event?.id === 5 ? S.backgroundLogistics : S.backgroundMain}`}
                                onClick={openModal}
                            >
                                {event?.id === 5 || event?.id === 1 ? "ЗАРЕГИСТРИРОВАТЬСЯ" : "ЗАПРОСИТЬ ОТЧЕТ"}
                            </button>
                            <div className={S.picture}>
                                {event?.id === 5 ? (
                                    <img src={logistic} alt="logistic"/>
                                ) : (
                                    event?.id === 1 ? (
                                        <img src={digitalization} alt="digitalization"/>
                                        ) : (
                                        <img src={bannerBackground} alt="bannerBackground"/>
                                    )
                                )}
                                <div className={S.datePicture}>
                                    {event?.date?.map((item, index) => (
                                        <div key={index}>{item}</div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {event?.registration ? (
                            <div className={S.divTable}>
                                {event?.days ? (
                                    <div className={S.tableCell}>
                                        <div className={`${S.numberTable} ${event?.id === 5 ? S.colorLogistics : S.colorMain}`}>{event?.days}</div>
                                        <div className={S.textTable}>дня деловой программы
                                        </div>
                                    </div>
                                ) : null}
                                {event?.excursion ? (
                                    <div className={S.tableCell}>
                                        <div className={`${S.numberTable} ${event?.id === 5 ? S.colorLogistics : S.colorMain}`}>{event?.excursion}</div>
                                        <div className={S.textTable}>день экскурсии на комбинат
                                        </div>
                                    </div>
                                ) : null}
                                {event?.participants ? (
                                    <div className={S.tableCell}>
                                        <div className={`${S.numberTable} ${event?.id === 5 ? S.colorLogistics : S.colorMain}`}>{event?.participants}</div>
                                        <div className={S.textTable}>участников
                                        </div>
                                    </div>
                                ) : null}
                                {event?.participatingEnterprises ? (
                                    <div className={S.tableCell}>
                                        <div className={`${S.numberTable} ${event?.id === 5 ? S.colorLogistics : S.colorMain}`}>{event?.participatingEnterprises}</div>
                                        <div className={S.textTable}>предприятий-участников
                                        </div>
                                    </div>
                                ) : null}
                                {event?.company ? (
                                    <div className={S.tableCell}>
                                        <div className={`${S.numberTable} ${event?.id === 5 ? S.colorLogistics : S.colorMain}`}>{event?.company}</div>
                                        <div className={S.textTable}>компаний-партнёров и экспонентов
                                        </div>
                                    </div>
                                ) : null}
                                {event?.representatives ? (
                                    <div className={S.tableCell}>
                                        <div className={`${S.numberTable} ${event?.id === 5 ? S.colorLogistics : S.colorMain}`}>{event?.representatives}</div>
                                        <div className={S.textTable}><span>представителей</span> крупнейших компаний
                                            горнодобывающего,
                                            металлургического, нефтегазового и
                                            энергетического секторов
                                        </div>
                                    </div>
                                ) : null}
                                {event?.reports ? (
                                    <div className={S.tableCell}>
                                        <div className={`${S.numberTable} ${event?.id === 5 ? S.colorLogistics : S.colorMain}`}>{event?.reports}</div>
                                        <div className={S.textTable}><span>прикладных докладов</span> от
                                            экспертов-практиков,
                                            аналитиков,
                                            представителей науки и бизнеса
                                        </div>
                                    </div>
                                ) : null}
                                {event?.space ? (
                                    <div className={S.tableCell}>
                                        <div className={`${S.numberTable} ${event?.id === 5 ? S.colorLogistics : S.colorMain}`}>{event?.space}</div>
                                        <div className={S.textTable}><span>деловой зоны</span> включая зал пленарных
                                            сессий,
                                            технические секции,
                                            выставочное пространство,
                                            зоны нетворкинга
                                        </div>
                                    </div>
                                ) : null}
                                {event?.hall ? (
                                    <div className={S.tableCell}>
                                        <div className={`${S.numberTable} ${event?.id === 5 ? S.colorLogistics : S.colorMain}`}>{event?.hall}</div>
                                        <div className={S.textTable}><span>зала</span> с полноценной, насыщенной
                                            программой
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        ) : null}

                        {event?.registration ? (
                            <Program event={event?.id} program={event?.program}/>
                        ) : null}

                        {!event?.registration ? (
                            event?.images?.length ? (
                                <Photo photo={event?.images}/>
                            ) : null
                        ) : null}

                        {event?.aboutEvent ? (
                            <DescriptionEvent id={event?.aboutEvent}/>
                        ) : null}

                        {event?.registration ? (
                            event?.questions?.length ? (
                                <Questions questions={event?.questions} event={event?.id} />
                            ) : null
                        ) : null}

                        {event?.registration ? (
                            event?.hallLayoutImg && (
                                <HallLayout img={event?.hallLayoutImg} />
                            )
                        ) : null}

                        {event?.registration ? (
                            event?.partners?.length && (
                                <div className={S.boxTitlePartners}>
                                    <div className={S.titlePartner}>ПАРТНЕРЫ ФОРУМА</div>
                                    <Carousel
                                        slideSize={{base: '200px', sm: '300px', md: '360px'}}
                                        slideGap="md"
                                        withControls={false}
                                        withIndicators={false}
                                        plugins={[autoScroll.current]}
                                        emblaOptions={{align: 'start', loop: true, dragFree: true}}
                                        className={S.carousel}
                                    >
                                        {event?.partners?.map((partner) => (
                                            <Carousel.Slide key={partner.id}>
                                                <Paper
                                                    className={S.partnerCard}
                                                    onClick={() => handleOpenModal(partner.id)}
                                                >
                                                    <Group className={S.partnerCardImg} justify="center" h="100%">
                                                        <Image
                                                            src={partner.images}
                                                            alt={partner.title}
                                                            className={S.partnerLogo}
                                                            fit="contain"
                                                        />
                                                    </Group>
                                                </Paper>
                                            </Carousel.Slide>
                                        ))}
                                    </Carousel>
                                </div>
                            )
                        ) : null}

                        {event?.registration ? (
                            <DescriptionQuestionEvent id={event?.aboutEvent} />
                        ) : null}

                        {event?.registration ? (
                            <ParticipationFormats event={event?.id}/>
                        ) : null}

                        {event?.registration ? (
                            <Registration event={event?.id}/>
                        ) : (
                            <EventSubscription/>
                        )}

                        {event?.registration ? (
                            <DescriptionEventContacts id={event?.aboutEvent} />
                        ) : null}
                    </div>
                </div>
                <div>
                    {event?.registration ? (
                        <Contacts contacts={event?.id}/>
                    ) : null}
                </div>
            </div>
            <PartnersModal
                opened={opened}
                close={close}
                idPartners={openModalId}
            />
            <ModalWindow
                opened={openedModal}
                close={closeModal}
                titleModal={event?.id === 5 || event?.id === 1 ? "Регистрация" : "Запросить отчет"}
                event={event?.id}
                question={!(event?.id === 5 || event?.id === 1)}
                textMessage={event?.id === 5 || event?.id === 1 ? "" : "Отправьте, пожалуйста, отчет о мероприятии."}
            />
        </section>
    );
};